__turbopack_context__.v({
  "chevron": "passenger-select-module-scss-module__nhOUPW__chevron",
  "chevronOpen": "passenger-select-module-scss-module__nhOUPW__chevronOpen",
  "dropdown": "passenger-select-module-scss-module__nhOUPW__dropdown",
  "inputIcon": "passenger-select-module-scss-module__nhOUPW__inputIcon",
  "label": "passenger-select-module-scss-module__nhOUPW__label",
  "option": "passenger-select-module-scss-module__nhOUPW__option",
  "placeholder": "passenger-select-module-scss-module__nhOUPW__placeholder",
  "root": "passenger-select-module-scss-module__nhOUPW__root",
  "selectContainer": "passenger-select-module-scss-module__nhOUPW__selectContainer",
  "selectField": "passenger-select-module-scss-module__nhOUPW__selectField",
  "selectText": "passenger-select-module-scss-module__nhOUPW__selectText",
  "selected": "passenger-select-module-scss-module__nhOUPW__selected",
});
